import { useState } from 'react';
import _ from 'lodash';

import { useMsal } from "@azure/msal-react";
import { notification } from 'antd';

import { Product, ProductAestheticMotif, ProductFilter } from '../../../../api-client';
import { CustomerApiClient } from '../../../../providers/api-provider';
import { validateCustomer } from '../../../../utils/axios-helpers/request-validation-helper';
import { isSameGender } from '../../../../utils/gender-utils';

export const useProducts = () => {
    const {
        instance
    } = useMsal();

    const [aestheticMotifs, setAestheticMotifs] = useState<ProductAestheticMotif[]>();
    const [aestheticMotifsLoading, setAestheticMotifsLoading] = useState<boolean>(false);

    const handleAestheticMotifs = async (id: number = -1, businessUnitCode: string) => {
        setAestheticMotifsLoading(true);

        validateCustomer(id);

        const clientApi = await CustomerApiClient(instance);

        clientApi.getCustomerProductAestheticMotifs(id, businessUnitCode)
            .then((response) => {
                setAestheticMotifs(response.data);
            })
            .catch((reason) => {
                setAestheticMotifs([]);

                notification.error({
                    message: 'Unable to retrieve aesthetic motifs!',
                    description: 'Unable to retrieve aesthetic motifs.',
                    duration: 2
                });
            })
            .finally(() => {
                setAestheticMotifsLoading(false);
            });
    }

    const [products, setProducts] = useState<Product[]>();
    const [productsLoading, setProductsLoading] = useState<boolean>(false);

    const handleProducts = async (id: number = -1, productFilter: ProductFilter, productsRefinements: any = {}) => {
        setProductsLoading(true);

        validateCustomer(id);

        const clientApi = await CustomerApiClient(instance);

        clientApi.getCustomerProductsByFilter(id, productFilter)
            .then((response) => {
                // setProducts(response.data);
                _handleProductsByFilters(response.data, productsRefinements);
            })
            .catch((reason) => {
                setProducts([]);

                notification.error({
                    message: 'Unable to retrieve products!',
                    description: 'Unable to retrieve products.',
                    duration: 2
                });
            })
            .finally(() => {
                setProductsLoading(false);
            });
    }

    const _handleProductsByFilters = (responseProducts: Product[], dataFilter: any) => {
        let tempData = _.cloneDeep(responseProducts) || [];

        if (dataFilter.BV_BOOLEAN_Novelties) {
            tempData = tempData.filter((entry: Product) => entry.isNovelty === dataFilter.BV_BOOLEAN_Novelties);
        }
        if (dataFilter.BV_BOOLEAN_Limited) {
            tempData = tempData.filter((entry: Product) => entry.isLimitedEdition === dataFilter.BV_BOOLEAN_Limited);
        }
        if (dataFilter.BV_BOOLEAN_Exhibition) {
            tempData = tempData.filter((entry: Product) => entry.isExhibitionNovelty === dataFilter.BV_BOOLEAN_Exhibition);
        }
        if (dataFilter.BV_GENDER_Gender) {
            tempData = tempData.filter((entry: Product) => isSameGender(entry.gender, dataFilter.BV_GENDER_Gender));
        }

        setProducts(tempData);
    }

    return {
        handleAestheticMotifs,
        aestheticMotifs,
        aestheticMotifsLoading,
        handleProducts,
        products,
        productsLoading
    }
}
